// The default comparator is for any values that can be
// compared with '==', '<', '<=', '>', '>='.
function defaultComparator(target, candidate) {
  if (target < candidate) {
    return -1
  } else if (target > candidate) {
    return 1
  } else {
    return 0
  }
}

// Performs a search in O(log(n)) time.
function binarySearchPositionRecursive(sortedList, target, low, high, comparator) {
  if (high < low) {
    return { exact: null, insert: high };
  }

  const mid = Math.floor(low + ((high - low) / 2));
  const result = comparator(target, sortedList[mid]);

  if (result === 0) {
    // return sortedList[mid];
    return { exact: mid, insert: mid };
  } else if (result < 0) {
    return binarySearchPositionRecursive(sortedList, target, low, mid - 1, comparator);
  } else {
    return binarySearchPositionRecursive(sortedList, target, mid + 1, high, comparator);
  }
}

export const binarySearchPosition = (sortedList, target, comparator = defaultComparator) => {
  return binarySearchPositionRecursive(sortedList, target, 0, sortedList.length - 1, comparator);
}